<template>
	<div class="previousTrip">
		<v-menu
				open-on-hover
		>

			<template v-slot:activator="{ on, attrs }">
				<v-btn
						v-bind="attrs"
						v-on="on"
						type="button"
						class="previousTripBtn"
						color="success"
						depressed
				>
					<span class="btnText">Previous trip</span>
					<span class="btnIco">
						<svg-sprite icon-id="arrow" width="20" height="20"></svg-sprite>
					</span>
				</v-btn>
			</template>
			<v-card>
				<div class="cardWrapper">
					<div class="head">
						<v-btn
								@click="onOpenOldTrip"
								type="button"
								class="previousTripBtn"
								color="success"
								depressed
						>
								<span class="btnIco">
									<svg-sprite icon-id="eye" width="20" height="20"></svg-sprite>
								</span>
							<span class="btnText">Open old trip #{{ oldRoute.trip_id }}</span>
						</v-btn>
					</div>
					<div class="main">
						<div class="mainTitle">Route</div>
						<div class="listWrap">
							<div class="item">
								<div class="number pickup">
									<svg-sprite icon-id="icon_download" width="20" height="20"></svg-sprite>
									<div class="text">{{ oldRoute.rout[0].load_id }}</div>
								</div>
								<div class="address">
									<div class="add">
										<span class="text">{{ oldRoute.rout[0].city }}</span>,
										<span class="text">{{ oldRoute.rout[0].state }}</span>,
										<span class="text">{{ oldRoute.rout[0].zip_code }}</span>
									</div>
									<div class="date">
										<span class="text">{{ oldRoute.rout[0].date }}</span>
									</div>
								</div>
							</div>
							<div class="item">
								<div class="number delivery">
									<svg-sprite icon-id="upload" width="20" height="20"></svg-sprite>
									<div class="text">{{ oldRoute.rout[1].load_id }}</div>
								</div>
								<div class="address">
									<div class="add">
										<span class="text">{{ oldRoute.rout[1].city }}</span>,
										<span class="text">{{ oldRoute.rout[1].state }}</span>,
										<span class="text">{{ oldRoute.rout[1].zip_code }}</span>
									</div>
									<div class="date">
										<span class="text">{{ oldRoute.rout[1].date }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</v-card>
		</v-menu>
	</div>
</template>

<script>
export default {
	name: "PreviousTrip",
	props: {
		oldRoute: Object,
	},
	data() {
		return {
			trip_id: null,
			rout: null,
		};
	},
	methods: {
		onOpenOldTrip() {
			this.$emit('updateOpenOldTrip', this.trip_id);
		},
	},
	mounted() {
		const { trip_id, rout, } = this.oldRoute;
		this.trip_id = trip_id;
		this.rout = rout;
	}
};
</script>

<style scoped lang="scss">
@import "PreviousTrip";
</style>
